<script setup lang="ts">
import { pointFormat } from '~/common/NumberFormater'
import { POINT_UNIT } from '~/common/constants'
const { trackButtonClick } = useAnalytics()
const { $alert, $dialog } = useNuxtApp()
const route = useRoute()
const app = useAppStore()
const dataStore = useDataStore()

const pointPopup = usePoint()
const selectedMenu = (path: string) => {
  // 현재 경로를 반응적으로 감지
  const currentPath = route.path

  // 현재 경로가 지정된 path로 시작하면 'active' 반환, 그렇지 않으면 빈 문자열 반환
  return currentPath.startsWith(path) ? 'active' : ''
}

const openCharge = () => {
  // 충전하기 버튼 클릭 시 동작
  trackButtonClick('click_charge_button', '충전하기', {
    um_idx: app.user.UM_IDX,
    date: new Date().toISOString(),
  })
  pointPopup.showDropsPackageLoad()
}

const navigateToQuick = () => {
  // 세션 키 생성
  const uniqueKey = `quick_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`

  // dataStore에 세션 생성
  dataStore.setSession(uniqueKey, {
    path: 'quick',
    selectedItems: {},
    selectedCards: [],
    selectedCount: 0,
    totalDrops: 5, // 빠른 생성 기본 포인트
    inputData: {
      materialHeader: '',
      passageContent: '',
      koreanTranslation: '',
    },
  })

  // 세션 키와 함께 이동
  useRouter().push(`/quick/?key=${uniqueKey}`)
}

onMounted(async () => {
  await pointPopup.getTotalDrops()
})

onUpdated(async () => {
  await pointPopup.getTotalDrops()
})
</script>
<template>
  <aside id="sideMenu">
    <h1>
      <a @click="navigateToQuick">
        <img src="~/assets/images/common/logo_jadoo.svg" alt="" />
      </a>
    </h1>
    <nav>
      <ul>
        <li>
          <a
            class="gnbFastCreate"
            :class="selectedMenu('/quick')"
            @click="navigateToQuick"
            >빠른 생성</a
          >
        </li>
        <li>
          <a
            class="gnbCustomCreate"
            :class="selectedMenu('/data')"
            @click="
              () => {
                useRouter().push('/data/?category=001')
              }
            "
            >맞춤 생성</a
          >
        </li>
        <li>
          <a
            class="gnbMyStorage"
            :class="selectedMenu('/myStorage')"
            @click="
              () => {
                useRouter().push('/myStorage')
              }
            "
          >
            내 자료함
          </a>
        </li>
        <li>
          <a
            class="gnbTextBank"
            :class="selectedMenu('/passageStorage')"
            @click="
              () => {
                useRouter().push('/passageStorage')
              }
            "
          >
            지문 보관함
          </a>
        </li>
      </ul>
    </nav>
    <section class="utilMenu">
      <p class="drops">
        <a
          @click="
            () => {
              useRouter().push('/point/list')
            }
          "
        >
          {{ POINT_UNIT }} {{ pointFormat(app.user.POINT) }}개
        </a>
      </p>
      <p class="buy">
        <a @click="openCharge"> 충전하기 </a>
      </p>
    </section>
  </aside>
</template>
